export default () => (
	<div class="rias-content col-span-full">
		<h2 class="headline-lg">Contact Information for RIAS-regs</h2>

		<p class="mb-6 text-gray-700 leading-relaxed">
			If you have any questions about the RIAS-regs website, please contact either the Scheme
			Administrator or the Website Administrator using the contact details below.
		</p>

		<div class="w-[50%] mx-auto grid grid-cols-[1fr_3fr] gap-4 mb-6 text-gray-700 leading-relaxed">
			<span class="font-semibold text-nowrap">Scheme Administration</span>

			<dl class="grid grid-cols-2 gap-4">
				<dt class="text-right font-bold">Contact:</dt>
				<dd>Scheme Administrator</dd>

				<dt class="text-right font-bold">Email:</dt>
				<dd>
					<a href="mailto:rias-regs@rias.org.uk">rias-regs@rias.org.uk</a>
				</dd>
			</dl>

			<span class="font-semibold text-nowrap">Website Administration</span>
			<dl class="grid grid-cols-2 gap-4">
				<dt class="text-right font-bold">Company:</dt>
				<dd>Home Energy and Data Services Limited</dd>

				<dt class="text-right font-bold">Contact:</dt>
				<dd>Development Team</dd>

				<dt class="text-right font-bold">Email:</dt>
				<dd>
					<a href="mailto:support@home-data.co.uk">support@home-data.co.uk</a>
				</dd>
			</dl>
		</div>
	</div>
);
